import React from "react";
import Movie from "../component/Movie";
import NavigationBar from "../component/Layout/NavigationBar";
function MoviePage() {
  return (
    <>
      <NavigationBar />
      <Movie />;
    </>
  );
}

export default MoviePage;
